/** 로그인·새로고침 직후 예산노트 LS↔서버 head 비교를 한 번만 돌리기 위한 플래그 */

let pendingLoginHeadSync = false;

export function markBudgetNoteLoginHeadSyncPending(): void {
  pendingLoginHeadSync = true;
}

export function consumeBudgetNoteLoginHeadSyncPending(): boolean {
  if (!pendingLoginHeadSync) return false;
  pendingLoginHeadSync = false;
  return true;
}
